import { render, staticRenderFns } from "./LegalAdviceView.vue?vue&type=template&id=492ff435"
import script from "./LegalAdviceView.vue?vue&type=script&lang=js"
export * from "./LegalAdviceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports